// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3cD9a","select":"Header_select__1lHVF","clinic":"Header_clinic__wh214"};